<template>
  <div v-if="inprogress">
    {{$t('SEARCH_LABEL_LOADING')}}
  </div>
  <div v-else class="c-search-counter">
    <span class="c-search-counter__count">{{count}}</span>
    <slot></slot>
    <span class="c-search-counter__term">{{term}}</span>
  </div>
</template>

<script>
export default {
  name: 'SearchCounter',

  props: {
    count: Number,
    term: String,
    inprogress: {
      type: Boolean,
      default: false
    }
  }
}
</script>
